/**
 * The "back to my location" map button: where it sits and what the camera does.
 */
import { getPanToDuration } from './moveGesture';

/**
 * The neighbourhood zoom the app already uses for a member's own area: the search
 * map's `initialZoom` (Search.tsx passes 14) and the zoom of the city-search
 * `flyTo` in the same file. Reused, not invented.
 */
export const NEIGHBORHOOD_ZOOM = 14;

/** The locate button is 44px (the touch target size) and round. */
export const LOCATE_BUTTON_SIZE_PX = 44;
/** Inset from the map's top and right edges (matches the dev zoom readout's 10px). */
export const LOCATE_BUTTON_INSET_PX = 10;
/**
 * Height of the dev-only zoom readout (12px monospace, about a 15px line, plus its 8px
 * top and bottom padding) and the gap under it. Only added in development, where the
 * readout occupies the top-right corner the button would otherwise take.
 */
export const DEV_ZOOM_READOUT_HEIGHT_PX = 31;
export const LOCATE_BUTTON_GAP_PX = 8;

/** Top offset of the locate button: below the zoom readout in dev, at the inset in production. */
export function getLocateButtonTopPx(isDev: boolean): number {
  return isDev
    ? LOCATE_BUTTON_INSET_PX + DEV_ZOOM_READOUT_HEIGHT_PX + LOCATE_BUTTON_GAP_PX
    : LOCATE_BUTTON_INSET_PX;
}

/**
 * `easeTo` options that bring the member's location to the middle of the map at
 * neighbourhood zoom: one short ease (350ms; instant under reduced motion). No event
 * data is attached, so it is a programmatic move: it never counts as a member gesture
 * (see moveGesture.ts) and never starts a search.
 */
export function getLocateCameraOptions(position: { lat: number; lng: number }, prefersReducedMotion: boolean) {
  return {
    center: [position.lng, position.lat] as [number, number],
    zoom: NEIGHBORHOOD_ZOOM,
    duration: getPanToDuration(prefersReducedMotion),
  };
}
